import { ChangeDetectionStrategy, Component, computed, inject, signal, viewChild } from '@angular/core'
import { RouterLink } from '@angular/router'
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay'

import { ActiveRoute, AppStore, AuthService } from '@core/index'
import { IconApp, Image } from '@shared/components'
import { Clicks } from '@shared/directives'
import { getVisibleNavItems } from '@layout/nav-items'

import { UserProfileBadge } from '../user-profile-badge/user-profile-badge'
import { ExtrasDropdown } from '../extras-dropdown/extras-dropdown'

@Component({
  selector: 'web-sidebar',
  imports: [UserProfileBadge, IconApp, RouterLink, CdkOverlayOrigin, CdkConnectedOverlay, ExtrasDropdown, Image, Clicks],
  templateUrl: './web-sidebar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'bg-primary-700 py-8 overflow-y-auto px-6 flex flex-col items-center justify-stretch gap-4 rounded-r-3xl border-2 border-accent-900'
  }
})
export class WebSidebar {
  #appStore = inject(AppStore)
  #activeRoute = inject(ActiveRoute)
  #authService = inject(AuthService)

  user = computed(() => this.#appStore.currentUser())

  navItems = computed(() => getVisibleNavItems(this.#appStore.currentUser()?.userType))
  isOpen = signal(false)
  trigger = viewChild(CdkOverlayOrigin)

  currentUrl = this.#activeRoute.currentUrl

  isActive(route: string): boolean {
    return this.#activeRoute.isActive(route)
  }

  logout() {
    this.#authService.logout()
  }
}
